export default class catalogEffectManager {
    constructor(){

    }
    photoCover($target,type){

        if(type==="set"){

            TweenMax.set($target.classList.contains('js__tsc-photo-cover'),{
                x:'100%'
            });

        }else{

            TweenMax.to($target,1.4, {
                delay:0.4,
                x:'100%',
                ease: Expo.easeOut,
            });
            TweenMax.to($target,0.3, {
                delay:0.4,
                rotation:6,
                transformOrigin:"50% 50%",
                ease: Expo.easeOut,
                onComplete:function(){
                    TweenMax.to($target,0.5, {
                        rotation: 0,
                        transformOrigin:"50% 50%",
                        ease: Expo.easeOut
                    });
                }
            });

        }

    }

    show($target,type){

        if(type==="set"){
            TweenMax.set($target,{
                opacity:0,
            });
        }else if(type==="out"){
            TweenMax.staggerTo($target,0.6, {
                opacity:0,
                ease: Power2.easeIn
            },0.05);
        }else{
            TweenMax.staggerTo($target,1.6, {
                delay:0.3,
                opacity:1,
                ease: Power2.easeOut
            },0.2);
        }

    }

    showScale($target,type){

        if(type==="set"){
            TweenMax.set($target,{
                opacity:0,
            });
        }else if(type==="out"){
            TweenMax.staggerTo($target,0.6, {
                opacity:0,
                ease: Power2.easeIn
            },0.05);
        }else{
            TweenMax.staggerTo($target,2.4, {
                delay:0.3,
                opacity:1,
                //scale:1.05,
                ease: Power2.easeOut,
                //className: "+=is-will"
            },0.2);
        }

    }

    showSlow($target,type){

        if(type==="set"){
            TweenMax.set($target,{
                opacity:0,
            });
        }else if(type==="out"){
            TweenMax.staggerTo($target,0.6, {
                opacity:0,
                ease: Power2.easeIn
            },0.05);
        }else{
            TweenMax.staggerTo($target,3, {
                delay:1.0,
                opacity:1,
                ease: Power2.easeOut
            },0.2);
        }

    }

    showX($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0, x:50});

        }else if(type==="out"){

            TweenMax.staggerTo($target,0.6, {
                x:-100,
                opacity:0,
                ease: "Power2.easeIn",
            },0.05);

        }else{

            TweenMax.staggerFromTo($target,0.7,
                {
                    x:50
                },
                {
                    x:0,
                    ease: "Power2.easeOut",
                },0.1);
            TweenMax.staggerTo($target,0.7, {
                opacity:1,
                ease: "Power2.easeIn",
            },0.1);

        }

    }
    showXslow($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0, x:50});

        }else if(type==="out"){

            TweenMax.staggerTo($target,0.6, {
                x:-100,
                opacity:0,
                ease: "Power2.easeIn",
            },0.05);

        }else{

            TweenMax.staggerFromTo($target,1.8,
                {
                    x:50
                },
                {
                    x:0,
                    ease: "Power2.easeOut",
                },0.1);
            TweenMax.staggerTo($target,0.7, {
                opacity:1,
                ease: "Power2.easeIn",
            },0.3);

        }

    }
    showX2($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0, x:100});

        }else if(type==="out"){

            TweenMax.staggerTo($target,0.6, {
                x:100,
                opacity:0,
                ease: "Power2.easeIn",
            },0.05);

        }else{

            TweenMax.staggerFromTo($target,1.8,
                {
                    x:-100
                },
                {
                    x:0,
                    ease: "Power2.easeOut",
                },0.1);
            TweenMax.staggerTo($target,0.7, {
                opacity:1,
                ease: "Power2.easeIn",
            },0.3);

        }

    }
    showY($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0, y:50});

        }else if(type==="out"){

            TweenMax.staggerTo($target,0.6, {
                y:-50,
                opacity:0,
                ease: "Power2.easeIn",
            },0.05);

        }else{
            TweenMax.staggerFromTo($target,0.7,
                {
                    y:50,
                    opacity:0
                },
                {
                    y:0,
                    opacity:1,
                    ease: "Power2.easeOut",
                },0.1);
            // TweenMax.staggerTo($target,0.7, {
            //     opacity:1,
            //     ease: "Power2.easeIn",
            // },0.1);

        }

    }
    showYslow($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0, y:50});

        }else if(type==="out"){

            TweenMax.staggerTo($target,0.6, {
                y:-50,
                opacity:0,
                ease: "Power2.easeIn",
            },0.05);

        }else{

            TweenMax.staggerFromTo($target,1.8,
                {
                    y:50
                },
                {
                    y:0,
                    ease: "Power2.easeOut",
                },0.3);
            TweenMax.staggerTo($target,0.9, {
                opacity:1,
                ease: "Power2.easeIn",
            },0.3);

        }

    }
    showLine($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0, x:50});

        }else if(type==="out"){

            TweenMax.staggerTo($target,0.6, {
                x:-100,
                opacity:0,
                ease: "Power2.easeIn",
            },0.05);

        }else{

            TweenMax.staggerFromTo($target,1.8,
                {
                    x:50,
                    width:'100px'
                },
                {
                    x:0,
                    width:'30px',
                    ease: "Power2.easeOut",
                },0.1);
            TweenMax.staggerTo($target,0.7, {
                opacity:1,
                ease: "Power2.easeIn",
            },0.1);

        }

    }
    feature($target,type){
        for(let i=0; i<$target.length; i++){
            if(type==="set"){
                TweenMax.set($target[i].querySelectorAll(".en > span"),{ opacity:0, y:-80});
                TweenMax.set([$target[i].querySelectorAll(".line"),$target[i].querySelectorAll(".num")],{ opacity:0});

            }else if(type==="out"){
                TweenMax.staggerTo($target,0.6, {
                    x:-100,
                    opacity:0,
                    ease: "Power2.easeIn",
                },0.05);
            }else{

                TweenMax.staggerFromTo($target[i].querySelectorAll(".en > span"),0.8,
                    {
                        y:-80
                    },
                    {
                        y:0,
                        ease: "Power2.easeOut",
                    },0.08);
                TweenMax.staggerTo($target[i].querySelectorAll(".en > span"),0.5, {
                    opacity:1,
                    ease: "Power2.easeIn",
                },0.08);
                TweenMax.staggerTo([$target[i].querySelectorAll(".line"),$target[i].querySelectorAll(".num")],0.7, {
                    delay:0.8,
                    opacity:1,
                    ease: "Power2.easeIn",
                },0.2);

            }
        }
    }
    fade($target,type){

        if(type==="set"){
            $target.insertAdjacentHTML("beforeend","<i class='js__tsc-cover'></i>");
            TweenMax.set($target.classList.contains('js__tsc-cover'),{
                x:'0%'
            });
        }else if(type==="out"){
            TweenMax.to($target.classList.contains('js__tsc-cover'),0.6, {
                opacity:0,
                z:-10,
                ease: Power2.easeIn,
            });
        }else{
            TweenMax.to($target.classList.contains('js__tsc-cover'),.8, {
                x:'100%',
                ease: Power2.easeInOut,
            });
        }

    }

    splitText($target,type){

        if($target.length == 0){
            return;
        }

        if(type === "set"){
            let text = new SplitText($target, {type:"words,chars"}),
                chars = text.chars;
            TweenMax.set(chars,{ opacity:0, x:20});
            // TweenMax.set(chars,{ opacity:0, x:100,rotationX:-20, rotationY:15});
        }else if(type === "out"){
            TweenMax.staggerTo($target, 0.6,
                {
                    opacity:0,x:150,
                    // filter:"blur(0px)",
                    ease: "Power2.easeIn",
                },
                0.01
            );
        }else{
            TweenMax.staggerTo($target, 0.8,
                {
                    // opacity:1,x:0,
                    x:0,
                    y:0,
                    z:0,
                    opacity:1,
                    scale:1,
                    ease: Expo.easeOut,
                },
                0.1
            );
        }
    }


    sectionTitle($target,type){

    }

    // kv($target,type){
    //
    //     if(type === "set"){
    //
    //         let _splittext = new SplitText(_title, {type:"words,chars"}),
    //             chars = _splittext.chars;
    //         TweenMax.set(chars,{
    //             y: 50,
    //             color: '#2bf3d9',
    //             opacity:0
    //         });
    //         TweenMax.set(_text,{ opacity:0});
    //         TweenMax.set(_line,{
    //             backgroundColor: '#2f3440',
    //             y:50,
    //             opacity:0
    //         });
    //
    //     }else if(type==="out"){
    //         TweenMax.staggerTo($target.classList.contains('js__tsc-title-title').children().children(),0.8, {
    //             y: -30,
    //             color: '#2bf3d9',
    //             opacity:0,
    //             ease: Power2.easeOut,
    //         },0.03);
    //         TweenMax.to($target.classList.contains('js__tsc-title-text'),0.8, {
    //             opacity:0,
    //             ease: Power2.easeOut,
    //         });
    //         TweenMax.to($target.classList.contains('js__tsc-title-line'),0.8, {
    //             backgroundColor: '#2f3440',
    //             y: -30,
    //             opacity:0,
    //             ease: Power2.easeOut,
    //         });
    //     }else{
    //
    //         $target.parents('.js__tsc').addClass('is-show');
    //
    //         TweenMax.to(_line,1.8, {
    //             opacity: 1,
    //             y:0,
    //             ease: Power4.easeOut
    //         });
    //         TweenMax.staggerFromTo(_title.children().children(),1.8, {
    //             y: 10,
    //             color: '#2bf3d9',
    //             opacity:0,
    //         },{
    //             delay:.15,
    //             y: 0,
    //             opacity:1,
    //             ease: Expo.easeOut,
    //             onStart:function(){
    //                 TweenMax.to(_line,1.2, {
    //                     delay:0.6,
    //                     backgroundColor: '#2bf3d9',
    //                     ease: Expo.easeOut
    //                 });
    //             }
    //         },0.05);
    //         TweenMax.staggerTo(_title.children().children(),2.1, {
    //             delay:.3,
    //             color: '#2f3440',
    //         },0.06);
    //
    //         TweenMax.to(_text,2, {
    //             delay:1,
    //             opacity: 1,
    //             ease: Expo.easeOut
    //         });
    //     }
    // }

}
